import Vue from 'vue'

export default new Vue({
  name: 'internalBus',
  methods: {
    onWindowResize () {
      this.$emit('resized', { origin: 'window' })
    }
  },
  mounted () {
    window.addEventListener('resized', this.onWindowResize)
    // this.$on('resized', evt => { console.log(evt) })
  },
  beforeDestroy () {
    window.removeEventListener('resized', this.onWindowResize)
    // this.$off('resized', evt => { console.log(evt) })
  }
})
